import { todayIST } from "components/Api/common";
import { useMasterContext } from "provider/MasterProvider";
import { Col, Container, Form, Row } from "react-bootstrap";
import Select from "react-select";
const { useSharedSafariContext } = require("provider/ShareSafariProvider");

const StepForm1 = () => {
    const { organizeSafari, organizeSafariErrors, sharedSafariDispatch } = useSharedSafariContext();
    const { parks } = useMasterContext();
 
  

    const updateFilter = (name, value) => {
        sharedSafariDispatch({
            type: "UPDATE_ORGANIZE_SHARE_SAFARI",
            payload: { [name]: value },
        });
        sharedSafariDispatch({
            type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
            payload: { [name]: '' },
        });
    };


    return (
        <Row className="pt-3">
            {/* Title */}
            <Col xs={12} className="mb-2">
                <Form.Label className="Modal_label">
                    Title <span className="necessary">*</span>
                </Form.Label>
                <Form.Group className="mb-3 field-sharedsafariform-share_safari_title required">
                    <Form.Control
                        type="text"
                        placeholder="Enter Title"
                        name="share_safari_title"
                        value={organizeSafari?.share_safari_title}
                        isInvalid={!!organizeSafariErrors?.share_safari_title}
                        onChange={(e) => updateFilter("share_safari_title", e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid" style={{ minHeight: "1.25rem" }}>
                        {organizeSafariErrors?.share_safari_title || "Title is required"}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>

            {/* Safari Park */}
            <Col xs={12} className="mb-2">
                <label className="Modal_label">
                    Select a Safari Park <span className="necessary">*</span>
                </label>
                <div className="mb-3 field-sharedsafariform-park_id required">
                    <Select
                        value={parks?.find((p) => p.value === organizeSafari?.park_id) || null}
                        onChange={(selectedOption) =>
                            updateFilter("park_id", selectedOption?.value || 0)
                        }
                        options={parks}
                        isSearchable
                        isClearable
                        placeholder="Select a Safari Park"
                        components={{ IndicatorSeparator: () => null }}
                    />
                    <div
                        className={`invalid-feedback ${organizeSafariErrors?.park_id ? "d-block" : ""}`}
                        style={{ minHeight: "1.25rem" }}
                    >
                        {organizeSafariErrors?.park_id}
                    </div>
                </div>
            </Col>

            {/* Start & End Dates */}
            {/* Start & End Dates */}
            <Col md={12}>
                <div className="d-flex gap-sm-3 align-items-start flex-sm-nowrap flex-wrap w-100 mb-1">
                    {/* Start Date */}
                    <div className="start w-100">
                        <Form.Label className="Modal_label">
                            Start Date <span className="necessary">*</span>
                        </Form.Label>
                        <Form.Group className="mb-3 field-sharedsafariform-start_date required">
                            <Form.Control
                                type="date"
                                name="start_date"
                                value={organizeSafari?.start_date}
                                isInvalid={
                                    !!organizeSafariErrors?.start_date ||
                                    (organizeSafari?.start_date && organizeSafari?.start_date < todayIST)
                                }
                                min={todayIST}
                                onChange={(e) => updateFilter("start_date", e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid" style={{ minHeight: "1.25rem" }}>
                                {organizeSafari?.start_date < todayIST
                                    ? "Start date cannot be before today"
                                    : organizeSafariErrors?.start_date || "Start date is required"}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </div>

                    <span className="pt-sm-4 text-center">-</span>

                    {/* End Date */}
                    <div className="start w-100">
                        <Form.Label className="Modal_label">
                            End Date <span className="necessary">*</span>
                        </Form.Label>
                        <Form.Group className="mb-3 field-sharedsafariform-end_date required">
                            <Form.Control
                                type="date"
                                name="end_date"
                                value={organizeSafari?.end_date}
                                isInvalid={
                                    !!organizeSafariErrors?.end_date ||
                                    (organizeSafari?.end_date &&
                                        organizeSafari?.end_date <= organizeSafari?.start_date)
                                }
                                min={organizeSafari?.start_date || todayIST}
                                onChange={(e) => updateFilter("end_date", e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid" style={{ minHeight: "1.25rem" }}>
                                {organizeSafari?.end_date &&
                                    organizeSafari?.end_date <= organizeSafari?.start_date
                                    ? "End date must be after start date"
                                    : organizeSafariErrors?.end_date || "End date is required"}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </div>
                </div>
            </Col>
            {/* Number of Safaris */}
            <Col xs={12} className="mb-1">
                <Form.Label className="Modal_label">Number of Safaris</Form.Label>
                <Form.Group className="mb-3">
                    <Form.Range
                        name="no_of_safari"
                        min="1"
                        max="10"
                        value={organizeSafari?.no_of_safari || 1}
                        onChange={(e) => updateFilter("no_of_safari", parseInt(e.target.value))}
                        className="range-slider w-100"
                    />
                    <div className="text-start">
                        <small>
                            No. of Safaris: <strong>{organizeSafari?.no_of_safari || 1}</strong>
                        </small>
                    </div>
                </Form.Group>
            </Col>
        </Row>

    );
};

export default StepForm1;